// ==== GPS SDK for Capacitor iframe ====

let _reqId = 0
const _callbacks = {}

function _callNative(type, payload = {}) {
  return new Promise(resolve => {
    const id = ++_reqId
    _callbacks[id] = resolve

    window.parent.postMessage(
      {
        type,
        payload,
        requestId: id,
      },
      '*',
    )
  })
}

window.addEventListener('message', e => {
  const d = e.data
  if (d?.requestId && _callbacks[d.requestId]) {
    _callbacks[d.requestId](d)
    delete _callbacks[d.requestId]
  }
})

/* ================= PUBLIC API ================= */

export async function requestLocation() {
  const res = await _callNative('REQUEST_LOCATION_PERMISSION')

  if (!res.coords) {
    throw new Error('Location permission denied')
  }

  return {
    lat: res.coords.latitude,
    lng: res.coords.longitude,
    accuracy: res.coords.accuracy,
    heading: res.coords.heading,
    speed: res.coords.speed,
  }
}

export async function getCurrentPosition(options = {}) {
  const res = await _callNative('REQUEST_LOCATION_PERMISSION')

  if (!res.coords) {
    throw new Error('Location permission denied')
  }

  return {
    lat: res.coords.latitude,
    lng: res.coords.longitude,
    accuracy: res.coords.accuracy,
    heading: res.coords.heading,
    speed: res.coords.speed,
  }
}

export function startLiveLocation(onUpdate) {
  window.addEventListener('message', e => {
    if (e.data?.type === 'DEVICE_LOCATION_UPDATE') {
      onUpdate({
        lat: e.data.payload.latitude,
        lng: e.data.payload.longitude,
        accuracy: e.data.payload.accuracy,
        heading: e.data.payload.heading,
        speed: e.data.payload.speed,
      })
    }
  })

  window.parent.postMessage({ type: 'START_LOCATION_STREAM' }, '*')
}

export function stopLiveLocation() {
  window.parent.postMessage({ type: 'STOP_LOCATION_STREAM' }, '*')
}
